import axios from "axios";
import { setisLoading } from "../services/loaderService";
import {
  notifyError,
  triggerExpSession,
} from "../services/axiosErrorListenerService";
import { renewToken } from "../services/authConfig";

export const axiosInterceptor = () => {
  let isRefreshing = false;
  let failedQueue = [];

  const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });
    failedQueue = [];
  };

  axios.interceptors.request.use(
    (config) => {
      if (!config.hideLoader) setisLoading(true);
      const idToken = localStorage.getItem("u_tk");

      if (idToken) {
        config.headers.Authorization = "Bearer " + idToken;
      }

      return config;
    },
    (error) => {
      setisLoading(false);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      setisLoading(false);
      if (
        response.config.responseType === "blob" ||
        response.config.responseType === "arraybuffer"
      ) {
        return response;
      }
      if (![200, 201, 204].includes(response.data.responseCode)) {
        const errorMessage = response.data?.message
          ? response.data?.message
          : "Oh it seems that an unexpected error has occurred, we apologize for the inconvenience, please try again.";
        notifyError(errorMessage);
      }
      if (response.data.responseCode == 430) {
        const errorMessage = "Company is required.";
        notifyError(errorMessage);
        return Promise.reject(null);
      }
      return response;
    },
    async (error) => {
      console.warn(error);
      setisLoading(false);
      const originalRequest = error.config;

      if (error.response?.status === 401) {
        if (!originalRequest) {
          triggerExpSession(true);
          return Promise.reject(error);
        }

        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return axios(originalRequest);
            })
            .catch((err) => {
              return Promise.reject(err);
            });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        try {
          const result = await renewToken();

          if (result.isAuthenticated) {
            const newToken = localStorage.getItem("u_tk");

            if (newToken) {
              processQueue(null, newToken);

              originalRequest.headers.Authorization = `Bearer ${newToken}`;
              return axios(originalRequest);
            } else {
              throw new Error("No token found after renewal");
            }
          } else {
            throw new Error("Token renewal failed");
          }
        } catch (refreshError) {
          console.error("Token Can't be renewed:", refreshError);
          // Procesar cola con error
          processQueue(refreshError, null);
          triggerExpSession(true);
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }
      if(error.response?.status !== 401){
         const message = error.response.data.message
          notifyError(message);
      }

      return Promise.reject(error);
    }
  );
  // axios.interceptors.response.use(
  //   (response) => {
  //     setisLoading(false);
  //     if (
  //       response.config.responseType === "blob" ||
  //       response.config.responseType === "arraybuffer"
  //     ) {
  //       return response;
  //     }
  //     if (![200, 201, 204].includes(response.data.responseCode)) {
  //       const errorMessage = response.data?.message
  //         ? response.data?.message
  //         : "Oh it seems that an unexpected error has occurred, we apologize for the inconvenience, please try again.";
  //       notifyError(errorMessage);
  //     }
  //     if (response.data.responseCode == 430) {
  //       const errorMessage = "Company is required.";
  //       notifyError(errorMessage);
  //       return Promise.reject(null);
  //     }
  //     return response;
  //   },
  //   async (error) => {
  //     console.warn(error);
  //     setisLoading(false);
  //     const originalRequest = error.config;
  //     if (error.response?.status === 401) {
  //       triggerExpSession(true);
  //     }
  //     if (error.response?.status === 401 && !originalRequest._retry) {
  //       originalRequest._retry = true;

  //       try {
  //         await renewToken();

  //         const newToken = localStorage.getItem("u_tk");

  //         if (newToken) {
  //           originalRequest.headers.Authorization = `Bearer ${newToken}`;
  //           return axios(originalRequest);
  //         }
  //       } catch (e) {
  //         console.error("Token Can't be renewed:", e);
  //         triggerExpSession(true);
  //       }
  //     }

  //     // if (error.response?.status !== 401) {
  //     //   const message = error.response.data.message
  //     //   notifyError(message);
  //     // }

  //     return Promise.reject(error);
  //   }
  // );
};
